import React, { useEffect, useState } from "react";
import { Drawer, DrawerContent, useDisclosure } from "@heroui/react";
import ButtonMethodPayment from "../../components/ButtonMethodPayment";
import Invoice from "../../components/Invoice";
import { ReactComponent as Close } from "../../assets/close.svg";
import { ReactComponent as CardIcon } from "../../assets/card_blue.svg";
import FormCreditCard from "../../components/FormCreditCard";
import ButtomSave from "../../components/ButtomSave";
import { isMobile } from "react-device-detect";
import { useStore } from "../../lib/store";
import axios from "axios";
import { toast } from "sonner";
import PaymentStatus from "../../components/PaymanetStatus";
import RegisterCard from "../AreaCliente/RegisterCard";
import { AmplitudeLog } from "../../lib/amplitude";
import { ScrollArea } from "../../components-shadcn/scroll-area";
import Product from "./Product";
import { GenerateInvoice } from "./request_create_invoice";
import { isToday } from "../../lib/utils";

interface Props {
  formas: "cartao" | "pix" | "boleto";
  produto_type: "dinamometro_tracao" | "dinamometro_palmar" | "assinatura";
  produto: any;
  entrada: boolean;
  wide?: boolean
  fatura_dois_cartoes?: "primeira_fatura_cc" | "segunda_fatura_cc" | "";
  valor_fatura_cc?: string;
}

type IconKey = "error" | "success" | "processing";

interface TypePaymentStatus {
  open: boolean;
  icon: IconKey;
  title: string;
  legend: string;
}

const PaymentCreditCardCheckout: React.FC<Props> = ({ wide, formas, produto_type, produto, entrada, fatura_dois_cartoes, valor_fatura_cc }) => {

  const isFaturaDoisCartoes = Boolean(valor_fatura_cc);
  const invoicePrice = isFaturaDoisCartoes ? valor_fatura_cc : (entrada ? produto?.entrada : produto?.valor);

  const { credit_card } = useStore();
  const { set_sync_checkout } = useStore();
  const { user } = useStore();
  const { id_negocio } = useStore();
  const { id_pedido } = useStore();


  const [status_payment, set_status_payment] = useState<TypePaymentStatus>({
    open: false,
    icon: "processing",
    title: "",
    legend: "",
  });

  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();
  const [loading, set_loading] = useState(false);
  const [invoice, set_invoice]: any = useState();

  const keys: any = {
    assinatura: "Assinatura",
    dinamometro_tracao: "Dinamômetro de tração",
    dinamometro_palmar: "Dinamômetro palmar"
  }


  const handleGenerateInvoice = async () => {
    set_loading(true);

    try {
      const data = await GenerateInvoice({
        id_negocio: id_negocio,
        id_pedido: id_pedido,
        produto: {
          formas_pagamento: formas,
          tipo: produto_type,
          entrada: entrada,
          fatura_dois_cartoes: fatura_dois_cartoes ?? "",
        },
      });

      if (data.status_code === 200) {
        onOpen();
        set_invoice(data);
        set_sync_checkout(true);
      } else {
        toast.error("Falha na geração da fatura: " + data.msg);
      }
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      set_loading(false);
    }
  };

  const PayInvoice = async () => {
    set_loading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/pay_invoice",
        {
          invoice: invoice.id_fatura,
          checkout: true
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_status_payment({
          icon: "success",
          title: "Pagamento aprovado!",
          legend:
            "O pagamento foi aprovado com sucesso! Enviaremos a NF-e para o e-mail financeiro cadastrado.",
          open: true,
        });
        AmplitudeLog("Checkout_Pagamento_Processado", {
          status_pagamento: "aprovado",
        });
        set_loading(false);
        set_sync_checkout(true);
        onClose();
      } else {
        set_status_payment({
          icon: "error",
          title: "Falha no pagamento",
          legend: resposta.data.msg,
          open: true,
        });
        set_loading(false);
        AmplitudeLog("Checkout_Pagamento_Processado", {
          status_pagamento: "falha",
        });
        AmplitudeLog("Checkout_Pagamento_Processado", {
          nome_etapa: "modal_cartao",
          mensagem_erro: resposta.data.msg
        });
      }
    } catch (erro: any) {
      toast("Erro ao pagar fatura: " + erro.message, {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      AmplitudeLog("Checkout_Pagamento_Processado", {
        status_pagamento: "falha",
      });
      AmplitudeLog("Checkout_Pagamento_Processado", {
        nome_etapa: "modal_cartao",
        mensagem_erro: erro.message
      });
      set_loading(false);
    }
  };

  const AutorizePayment = async () => {
    set_loading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/autorized_payment",
        {
          invoice: invoice.id_fatura
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_loading(false);
        set_sync_checkout(true);
        onClose();
      } else {
        set_loading(false);
        toast("Erro ao registrar fatura: ", {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
      }
    } catch (erro: any) {
      set_loading(false);
      toast("Erro ao registrar fatura: " + erro.message, {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
    }
  };

  const HandleInvoiceMethod = () => {
    if (isToday(entrada ? produto.vencimento_fatura_entrada : produto.vencimento_fatura)) {
      PayInvoice();
    } else {
      AutorizePayment();
    }
  }

  useEffect(() => {
    if (isOpen)
      AmplitudeLog("Checkout_Modal_Cartao_Visualizado", {
        valor_fatura_exibido: entrada ? produto?.entrada : produto?.valor
      })
  }, [isOpen])


  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40" />}

      <ButtonMethodPayment
        onClick={() => {
          if (loading === false) {
            AmplitudeLog("Checkout_Metodo_Selecionado", {
              finalidade_pagamento: entrada ? "entrada" : produto_type,
              tipo_produto: produto_type,
              metodo_escolhido: "cartao",
              origem_escolha: "primeira_etapa"
            });
            handleGenerateInvoice();
          }
        }}
        icon="cartao"
        theme="mediumgreen"
        wide={wide}
        loading={loading}
      >
        Pague com Cartão
      </ButtonMethodPayment>

      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement={"bottom"}
        hideCloseButton
        onClose={() =>
          set_status_payment({
            icon: "processing",
            legend: "",
            open: false,
            title: "",
          })
        }
      >
        <DrawerContent
          className={`
          w-full
          rounded-t-[0.75rem]
          ${!isMobile && "!h-[100vh] !rounded-none !border-none"}
          h-[100dvh]
          bg-white-primary
          px-[2rem]
          flex items-center
        `}
        >
          {(onClose) => (
            <div
              className={`${!isMobile ? "w-[45%]" : "w-full"}`}
            >
              <div className="w-[100%] flex justify-end">
                <button
                  onClick={onClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    marginTop: "1.5rem",
                  }}
                >
                  <Close className="w-[1rem] h-[1rem]" />
                </button>
              </div>
              <ScrollArea className="h-[100%]">
                <div className="w-[100%] flex justify-center">
                  <p className="text-blue-primary text-[1.04rem] font-[700] mb-[1rem]">
                    Pagamento com Cartão
                  </p>
                </div>
                {!entrada && !isFaturaDoisCartoes &&
                  <Product
                    title={produto.plano ? produto.plano : keys[produto_type]}
                    valor={produto.valor}
                    total={produto.valor_total}
                    parcelas={produto.quantidade_parcelas}
                    unidades={produto.quantidade}
                    theme="gray"
                    imagem={produto_type}
                  />
                }

                <p className="text-gray-dark text-[1.04rem] mt-[1.8rem] font-[700]">
                  Fatura
                </p>
                <Invoice
                  duedate={entrada ? produto?.vencimento_fatura_entrada : produto?.vencimento_fatura}
                  price={invoicePrice}
                  parcelas={produto?.quantidade_parcelas}
                  theme="default"
                  quantidade={produto?.quantidade}
                  entrada={entrada || isFaturaDoisCartoes}
                />
                <hr />
                {credit_card?.id_token !== "" && !isFaturaDoisCartoes ? (
                  <div className="mb-[2rem]">
                    <p className="text-gray-dark text-[1.2rem] mt-[1.4rem] font-[700] my-[2rem]">
                      Cadastrar cartão
                    </p>
                    <div className="flex flex-col p-[0.75rem] border border-gray-medium rounded-[0.5rem]">
                      <p>Cartão cadastrado</p>
                      <div className="flex flex-row">
                        <CardIcon className="w-[1.3rem] h-[1.3rem] mr-[1rem] mt-[0.5rem]" />
                        <p className="mt-[0.5rem]">{credit_card?.num_card}</p>
                      </div>
                    </div>
                    <RegisterCard dotMode />
                    <ButtomSave
                      theme="mediumgreen"
                      icon="none"
                      className="mt-[2rem]"
                      loading={loading}
                      onClick={() => {
                        HandleInvoiceMethod();
                        AmplitudeLog("Checkout_Opcao_Reuso_Cartao", {
                          cartao_disponivel: true
                        });
                      }}
                    >
                      {
                        isToday(entrada ? produto.vencimento_fatura_entrada : produto.vencimento_fatura) ?
                          "Pagar com cartão cadastrado"
                          :
                          `${entrada ? "Pagar em " + produto.vencimento_fatura_entrada : "Pagar em " + produto.vencimento_fatura}`
                      }

                    </ButtomSave>
                  </div>
                ) : (
                  <FormCreditCard
                    invoice={invoice?.id_fatura}
                    name_button={
                      isToday(entrada ? produto.vencimento_fatura_entrada : produto.vencimento_fatura) ?
                        "Pagar com cartão cadastrado"
                        :
                        `${entrada ? "Pagar em " + produto.vencimento_fatura_entrada : "Pagar em " + produto.vencimento_fatura}`
                    }
                    entrada={entrada ? true : false}
                    produto={produto}
                  />
                )}
              </ScrollArea>

              <PaymentStatus
                open={status_payment.open}
                icon={status_payment.icon}
                title={status_payment.title}
                legend={status_payment.legend}
                close={() => set_status_payment({
                  icon: "processing",
                  legend: "",
                  open: false,
                  title: "",
                })}
              />
            </div>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default PaymentCreditCardCheckout;
